<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nXrR4n/tc-custom/9780830862559.jpg?1696025331322" alt="This image is the cover for the book Christian Community, LifeGuide Bible Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Christian Community, LifeGuide Bible Studies
      </h1>
      <p class="bookDescription body article font2">
        <p>One of the greatest gifts that Christ has given us is each other. Through Christ's body, the church, we discover our unique gifts and experience worship, healing and power. In this ten-session LifeGuide® Bible Study, Rob Suggs leads us to grow in community—loving and nurturing one another, and in reflecting Christ's love to the world around us. For over three decades LifeGuideBible Studies have provided solid biblical content and raised thought-provoking questions—making for a one-of-a-kind Bible study experience for individuals and groups. This series has more than 130 titles on Old and New Testament books, character studies, and topical studies. <strong>PDF download with a single-user license; available from InterVarsity Press and other resellers.</strong> </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rob Suggs
      </h2>
      
      <p class="authorDescription body article"><p>Rob Suggs is a writer who devotes most of his work to the Christian market. He has collaborated with Bruce Wilkinson, David Jeremiah, Bill Bright, Lee Strobel, Les Steckel, and others. Suggs specializes in finding the speaker's voice in prose, as well as communicating that personality's heart and soul in a manner that touches the reader's emotions. Suggs originally made his mark as a cartoonist whose work can be seen in<em>It Came from Beneath the Pew</em> and <em>Preacher from the Black Lagoon</em>. He is also the author of <em>The Ten Commandments, Christian Community</em> and <em>The Suggs Book of Family Tales</em>. He served for three years as a senior editor at Walk Through the Bible Ministries and is a graduate of Furman University.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1561586c